import React from 'react';
import { useAppState } from './AppStateContext';
import { TrackQuickSearchExitButton } from './SiteHeaderTracking';

const QuickSearchCloseButton = () => {
  const { showSearch, setShowSearch } = useAppState();

  const translations = window._THULEDATA._siteHeader.Translations;

  return (
    <div className={`quick-search-close-button ${showSearch ? '' : 'd-none'}`}>
      <button
        onClick={() => {
          setShowSearch(false);
          TrackQuickSearchExitButton();
        }}
      >
        {translations?.Close}
      </button>
    </div>
  );
};

export default QuickSearchCloseButton;
